import _extends from '@babel/runtime-corejs3/helpers/extends';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { useState, useEffect, useCallback, useMemo } from 'react';
import classNames from 'classnames';
import styles from './58fa1f07ab76fe84c9e4d2c411cd007cd60b7b4abeea917082422b73d3a79651.cfe-internal.js';
import PaginationPreviousButton from './9fa562e8a41330b4ec5b831b761d868d1d28f4886678405bff1cdb0a79a2937e.cfe-internal.js';
import PaginationNextButton from './933ae4d85f08339522ea145092144de8326eedfa67cff8bba4bc28e0ef8fe95e.cfe-internal.js';
import PaginationPageInput from './4a293ce1924c60e63e169428460bbe2378f373c2bc1faa4016ce7d6ee7d5137c.cfe-internal.js';
import { PaginationContextProvider } from './df75c05401804c6d8142b2bca56715be95f3ec399c9a77fd514147d01733223c.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import '../../hooks/useScreenReaderAnnouncement/9f7b01b00d007eb8e369f9b08f495cbecd6a9797bf02228d600045a7623c7694.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import useTranslation from '../../utils/Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';
import useScreenReaderAnnouncement from '../../hooks/useScreenReaderAnnouncement/512f506263b51a28e4f5625270af84bc8ecd591bd1100039f845b39b162a4827.cfe-internal.js';
import { useDidUpdate } from '../../hooks/useDidUpdate/f8ce5c85f293b5c4ca8be6bc5ac9f246003ac61cc91ab03b8814ccaab638a21a.cfe-internal.js';

var _excluded = ["data-testid", "numPages", "currentPage", "onPageChange", "className", "children", "aria-label", "aria-labelledby", "aria-describedby"];
/**
 * Renders the Pagination component.
 * This component is offered as a "default" (aka simple) component or an "advanced" (aka composite) component.
 */
var Pagination = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var dataTestId = _ref['data-testid'],
    numPages = _ref.numPages,
    _ref$currentPage = _ref.currentPage,
    currentPage = _ref$currentPage === void 0 ? 1 : _ref$currentPage,
    onPageChange = _ref.onPageChange,
    className = _ref.className,
    children = _ref.children,
    ariaLabel = _ref['aria-label'],
    ariaLabelledBy = _ref['aria-labelledby'],
    ariaDescribedBy = _ref['aria-describedby'],
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;

  // The current page (the consumer holds a current page that might be different)
  var _useState = useState(currentPage),
    _useState2 = _slicedToArray(_useState, 2),
    pageInputValue = _useState2[0],
    setPageInputValue = _useState2[1];
  var announceToScreenReader = useScreenReaderAnnouncement('assertive');

  // Announces the new page info to the screen reader when the page info changes, but not when the component first mounts
  useDidUpdate(function () {
    if (numPages) {
      announceToScreenReader(translate('pagination', {
        currentPage: currentPage,
        numPages: Number(numPages)
      }));
    }
  }, [announceToScreenReader, translate, currentPage, numPages]);

  // Updates the `pageInputValue` to be `currentPage` when the `currentPage` prop changes
  useEffect(function () {
    setPageInputValue(currentPage);
  }, [currentPage]);

  /**
   * Calls `onPageChange` if the function was passed in as a prop
   * @param {Number} newPage - The value entered into the input
   */
  var handlePageChange = useCallback(function (newPage) {
    onPageChange === null || onPageChange === void 0 || onPageChange({
      page: newPage
    });
  }, [onPageChange]);

  // Context for the composite components
  var context = useMemo(function () {
    return {
      numPages: numPages,
      pageInputValue: pageInputValue,
      currentPage: currentPage,
      dataTestId: dataTestId,
      ariaLabel: ariaLabel,
      ariaLabelledBy: ariaLabelledBy,
      ariaDescribedBy: ariaDescribedBy,
      handlePageChange: handlePageChange,
      setPageInputValue: setPageInputValue
    };
  }, [numPages, pageInputValue, currentPage, dataTestId, ariaLabel, ariaLabelledBy, ariaDescribedBy, handlePageChange, setPageInputValue]);
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    "data-testid": dataTestId,
    ref: ref,
    className: classNames(className, styles.pagination)
  }), /*#__PURE__*/React__default.createElement(PaginationContextProvider, {
    value: context
  }, children || /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PaginationPreviousButton, null), Number(numPages) > 0 ? /*#__PURE__*/React__default.createElement(PaginationPageInput, null) : null, /*#__PURE__*/React__default.createElement(PaginationNextButton, null))));
});
var Pagination$1 = Pagination;

export { Pagination$1 as default };
